import { createApp } from 'vue';
import App from './App.vue';
import router from "./modules/Router";
import Config from "./modules/Config";
import Session from "./modules/Session";
import '@syncfusion/ej2-base/styles/bootstrap.css';
import "@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
import "@syncfusion/ej2-vue-notifications/styles/bootstrap.css";
import '@syncfusion/ej2-vue-dropdowns/styles/bootstrap.css';
import '@syncfusion/ej2-vue-grids/styles/bootstrap.css';
import '@syncfusion/ej2-vue-popups/styles/bootstrap.css';
import "@syncfusion/ej2-vue-buttons/styles/bootstrap.css";
import { registerLicense } from '@syncfusion/ej2-base';
import "@syncfusion/ej2-vue-navigations/styles/bootstrap.css";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { register } from 'register-service-worker'
import { AppInsightsPlugin } from "vue3-application-insights";

const aiOptions = {
    appName: "NcasReporting-" + Config.Provider('environmentDisplayText'),
    connectionString: Config.Provider('app_insights'),
    router: router,
    trackAppErrors: true,
    trackInitialPageView: true,
    onLoaded: function (sdk) {
        sdk.context.user.id = Session.GetUserName();
    }
};

register(`/ncas-reporting-service-worker.js`, {
    ready() {
       
    },
    registered() {
        
    },
    cached() {

    },
    updatefound() {
        
    },
    updated() {
        
    },
    offline() {
        
    },
    error() {

    }
})

library.add(fas, far, fab)
dom.watch();

registerLicense(Config.Provider("ej_license"))
createApp(App)
    .use(AppInsightsPlugin, aiOptions)
    .use(router)
    .component("font-awesome-icon", FontAwesomeIcon)
    .mount('#app');